import { notifications } from '@/store/dashboard/notifications/notifications';
import { counters } from '@/store/dashboard/counters/counters';
import { roles } from '@/store/dashboard/roles/roles';
import { models } from '@/store/dashboard/models/models';
import { permissions } from '@/store/dashboard/permissions/permissions';
import { resources } from '@/store/dashboard/resources/resources';
import { users } from '@/store/dashboard/users/users';
import { address } from '@/store/dashboard/address/address';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { BuildingsModule } from '@/store/dashboard/buildings/BuildingsModule';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { BillingModule } from '@/store/dashboard/billing/BillingModule';
import { EventsModule } from '@/store/dashboard/events/EventsModule';
import { CounterDataModule } from '@/store/dashboard/counters-data/CounterDataModule';

export const dashboard = {
  namespaced: true,
  modules: {
    notifications,
    companies: CompaniesModule,
    counters,
    countersData: CounterDataModule,
    buildings: BuildingsModule,
    billing: BillingModule,
    accounts: AccountsModule,
    resources,
    permissions,
    roles,
    rates: RatesModule,
    locations: LocationsModule,
    models,
    users,
    address,
    providers: ProvidersModule,
    events: EventsModule,
  }
};
